import api from '@services/api';
import { VerificationApi, VerificationTierStatus } from '@services/generated';
import { handleErrors } from '@services/helpers';
import { rootApi } from '@store/root-api';
import appHelpers from '@utils/app-urls';

const API_URL = appHelpers.getEndpointUrl();

const verificationClient = new VerificationApi(
  undefined,
  new URL(API_URL, process.env.REACT_API_URL).href,
  api,
);

export const verificationApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    generateSumsubToken: builder.query<string, void>({
      queryFn: () =>
        handleErrors(async () => {
          return await verificationClient.generateAccessToken();
        }),
    }),
    markActionAsCompleteByUser: builder.mutation<void, string>({
      queryFn: actionCode =>
        handleErrors(async () => {
          return await verificationClient.markVerificationAsCompleteByUser(
            actionCode,
          );
        }),
      invalidatesTags: [{ type: 'UserProfile' }],
    }),
    getVerificationStatus: builder.query<VerificationTierStatus, void>({
      queryFn: data => handleErrors(() => verificationClient.tierStatus()),
    }),
  }),
});

export const {
  useGetVerificationStatusQuery,
  useGenerateSumsubTokenQuery,
  useMarkActionAsCompleteByUserMutation,
} = verificationApi;
